var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('v-sheet',{staticClass:"ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12"},[(_vm.loading)?[_c('opq-loading')]:[_vm._t("default")]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }